// Use the full build (with template compiler) to allow mounting on existing HTML
// This avoids blank pages when Vue tries to compile templates at runtime.
import Vue from 'vue/dist/vue.esm.js'
import Vuex from 'vuex'

import store from '@/store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
//
import { get } from 'lodash-es'
import simplebar from 'simplebar'

// Change serialization of arrays from Param[]=1&Param[]=2 to Param=1&Param=2
// as this is the way query strings are expected in dotnet core.
axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });

// In development, point axios to the local mock API server
if (process.env.NODE_ENV !== 'production') {
  const devApiBase = (typeof window !== 'undefined' && window.GPE_API_BASE) || 'http://localhost:9090'
  axios.defaults.baseURL = devApiBase
}

//
// Event bus
window.bus = new Vue({})
//
// Vue components
import Accordion from '@/components/accordion/accordion'
import BuyGuide from '@/components/buy-guide/buy-guide.vue'
import Checkout from '@/components/checkout/checkout'
import CookieDisclaimer from '@/components/cookie-disclaimer/cookie-disclaimer'
import debugConsole from '@/components/debug-console/debug-console.vue'
import FormBox from '@/components/form/form-box/form-box'
import FormModal from '@/components/form/form-modal/form-modal'
import Header from '@/components/header/header'
import IframeModal from '@/components/modal/iframe-modal/iframe-modal.vue'
import InfoNotice from '@/components/info-notice/info-notice'
import InfoTabs from '@/components/info-tabs/info-tabs'
import NavMobile from '@/components/nav-mobile/nav-mobile'
import Pagination from '@/components/product-list/pagination/pagination'
import ProductFilter from '@/components/product-filter/product-filter'
import ProductFilterToggle from '@/components/product-filter-toggle/product-filter-toggle'
import ProductList from '@/components/product-list/product-list'
import ProductPresentation from '@/components/product-presentation/product-presentation'
import ProductSlider from '@/components/product-presentation/product-slider/product-slider'
import ProductSort from '@/components/product-sort/product-sort'
import ScrollResize from '@/components/scroll-resize/scroll-resize'
import SearchShowAllButton from '@/components/search-show-all-button/search-show-all-button'
import ShoppingCart from '@/components/shopping-cart/shopping-cart'
import StoreSelect from '@/components/store-list/store-select/store-select'
import VueLazyload from 'vue-lazyload'

Vue.use(Vuex)
Vue.use(VueAxios, axios)
Vue.use(VueLazyload, {
  error:
    'data:image/png;charset=utf-8;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAADaCAMAAAD3w6zpAAAAM1BMVEUAAADi4uLp6enl5eXi4uLj4+Pi4uLh4eHk5OTh4eHh4eHi4uLj4+Ph4eHh4eHi4uLh4eHl9UBgAAAAEHRSTlMAgRAzoFrCU0AZ8Spg6cffYYBPmwAAASFJREFUeNrt3TF2gzAQRVEBMiQ4jtj/alOkZQqfhJEx9+7gNVP8ZgoAAAAAAAAAAACv4bO3cpRx620pv6RJu0Dacu9kPTxtKp1I+1va/ZZtykr72rLVvLT1O1PLTJtLpkGaNGn7pEmTJk1aRJo0adKkRaRJkyZNWuTMae2WqW7VeiztqmmPTKsLKU3aPmnSpEmTFpEmTZo0aRFp0qRJkxaRJi05bcw0GMalSQucOK1NmarjL03aPmnSpEmTFpEmTZo0aRFp0qRJkxaRJi03bZ0zNcO4tMumtSHT7EJKk7ZPmjRp0qRFpEmTJk1aRJo0adKkRaS9ZNqjZrL5/0faNGRbvAWRdr20Z53ocdIzpEk7Mq189DYWAAAAAAAAAADgDf0AVhkRfRV+b9UAAAAASUVORK5CYII=',
  loading:
    'data:image/png;charset=utf-8;base64,iVBORw0KGgoAAAANSUhEUgAAANoAAADaCAMAAAD3w6zpAAAAM1BMVEUAAADi4uLp6enl5eXi4uLj4+Pi4uLh4eHk5OTh4eHh4eHi4uLj4+Ph4eHh4eHi4uLh4eHl9UBgAAAAEHRSTlMAgRAzoFrCU0AZ8Spg6cffYYBPmwAAASFJREFUeNrt3TF2gzAQRVEBMiQ4jtj/alOkZQqfhJEx9+7gNVP8ZgoAAAAAAAAAAACv4bO3cpRx620pv6RJu0Dacu9kPTxtKp1I+1va/ZZtykr72rLVvLT1O1PLTJtLpkGaNGn7pEmTJk1aRJo0adKkRaRJkyZNWuTMae2WqW7VeiztqmmPTKsLKU3aPmnSpEmTFpEmTZo0aRFp0qRJkxaRJi05bcw0GMalSQucOK1NmarjL03aPmnSpEmTFpEmTZo0aRFp0qRJkxaRJi03bZ0zNcO4tMumtSHT7EJKk7ZPmjRp0qRFpEmTJk1aRJo0adKkRaS9ZNqjZrL5/0faNGRbvAWRdr20Z53ocdIzpEk7Mq189DYWAAAAAAAAAADgDf0AVhkRfRV+b9UAAAAASUVORK5CYII=',
})

Vue.prototype.$get = get

// No global store exposure in normal dev builds

const App = new Vue({
  el: '[vue-component]',
  store,
  components: {
    'buy-guide': BuyGuide,
    'cookie-disclaimer': CookieDisclaimer,
    'debug-console': debugConsole,
    'form-box': FormBox,
    'form-modal': FormModal,
    'iframe-modal': IframeModal,
    'info-notice': InfoNotice,
    'info-tabs': InfoTabs,
    'nav-mobile': NavMobile,
    'product-filter': ProductFilter,
    'product-list': ProductList,
    'product-presentation': ProductPresentation,
    'product-slider': ProductSlider,
    'product-sort': ProductSort,
    'scroll-resize': ScrollResize,
    'search-show-all-button': SearchShowAllButton,
    'shopping-cart': ShoppingCart,
    'site-header': Header,
    'store-select': StoreSelect,
    accordion: Accordion,
    checkout: Checkout,
    pagination: Pagination,
    productFilterToggle: ProductFilterToggle,
  },
})

export default App
